import { transport } from 'config/transport';

export function callApiDeleteBHYT(congDoanId, nunId, bhytId) {
    return transport.del(`/congdoan/${congDoanId}/baohiemyte/${nunId}/${bhytId}`);
}
